import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import React from "react";

function RadioCompo({ label, valueArray, ...props }) {
  return (
    <FormControl>
      <FormLabel id="demo-row-radio-buttons-group-label">{label}</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        {...props}
      >
        {valueArray?.map((e, i) => (
          <FormControlLabel value={e?.value} control={<Radio />} label={e?.title} />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

export default RadioCompo;
